import $ from "jquery";
window.$ = window.jQuery = $;

require('./form');
import Inputmask from "inputmask";
import 'jquery-validation';
import lightGallery from 'lightgallery';

$(document).ready(function () {

    lightGallery(document.getElementById('lightgallery'), {
        speed: 500,
        download: false
    });

    function initPhoneMask() {
        const im = new Inputmask("+38 099 999 99 99", {
            clearIncomplete: true,
            showMaskOnHover: false,
        });

        im.mask($('input[name="phone"]'));
    }
    window.initPhoneMask = initPhoneMask;
    initPhoneMask()

    $('.main-btn-toggle').on('click', function () {
        $('body').toggleClass('dark-theme');

        $(this).find('.main-btn-toggle__light').toggle();
        $(this).find('.main-btn-toggle__dark').toggle();

        if ($('body').hasClass('dark-theme')) {
            localStorage.setItem('theme', 'dark');
        } else {
            localStorage.setItem('theme', 'light');
        }
    });

    if (localStorage.getItem('theme') === null || localStorage.getItem('theme') === 'dark') {
        $('body').addClass('dark-theme');

        $('.main-btn-toggle').find('.main-btn-toggle__light').hide();
        $('.main-btn-toggle').find('.main-btn-toggle__dark').show();
    }


    $('.header-burger-menu').click(function(){
        $('body').toggleClass('hidden')
        $('.header__wrap').fadeToggle();
        $('.header-burger-menu').toggleClass('active');
        $('.dark-overlay').toggleClass('active');
    });


    $(window).scroll(function () {
        if ($(this).scrollTop() != 0)
        $('.main-arrow-top').fadeIn();
        else
        $('.main-arrow-top').fadeOut();
    });
    $('.main-arrow-top').click(function () {
        $('body,html').animate({
            scrollTop: 0
        }, 800);
    });


    function closeVideoModal() {
        $('.js_append_video').removeClass('active');
        $('.modal-video__wrap').empty();
    }

    $(document).on('click', '.js_actevate_video', function () {
        const btn = $(this);
        const type = btn.attr('data-type');
        const src = btn.attr('data-src');
        let htmlVideo = '';

        switch (type) {
            case 'video':
            htmlVideo = `<video width="100%" height="auto" controls autoplay> <source src="${src}" type="video/mp4"> Your browser does not support the video tag. </video>`;
            break;
            case 'iframe':
            htmlVideo = `<iframe allowfullscreen src="${src}?autoplay=1" width="100%" height="auto"></iframe>`;
            break;
        }
        $('.js_append_video').addClass('active');
        $('.modal-video__wrap').empty().append(htmlVideo);

        const video = $('.modal-video__wrap video')[0];
        if (video) {
            $(video).on('webkitendfullscreen', function () {
                closeVideoModal();
            });
            $(document).on('fullscreenchange', function () {
                if (!document.fullscreenElement) {
                    closeVideoModal();
                }
            });
        }

    });

    $(document).on('click', '.modal-video', function (e) {
        if ($(e.target).is('.modal-video')) {
            closeVideoModal();
        }
    });

});
